// extracted by mini-css-extract-plugin
module.exports = {"splashScreenWrapper":"SplashScreen_splashScreenWrapper__oA92K","loading":"SplashScreen_loading__EX8cb"};